import type { FC, ReactElement } from 'react';
import React, { useState } from 'react';
import { LogoMark } from '@/components';
import { MenuItem } from './MenuItem';
import { ProfileMenu } from '@/views/profile/ProfileMenu';
import { User } from 'react-feather';
import classes from './Menu.module.css';

interface Props {
  menu?: ReactElement;
  /*
    CSS overflow setting for page content. (Defaults to auto in component)
    Set to visible to allow content to be visible on top of menu in Safari.
  */
  contentOverflow?: string;
  inspectMode?: boolean;
  children?: React.ReactNode;
  hasPriority?: boolean;
}

export const Menu: FC<Props> = (props) => {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  return (
    <div data-testid="menu" className={classes.container}>
      <div data-testid="menu-logo" className={classes.logo}>
        <LogoMark theme="brand" size={32} />
      </div>
      <div className={classes.items}>
        {props.children}
        <div
          data-testid="menu-profile"
          data-state={isProfileMenuOpen ? 'open' : 'closed'}
          className={`${classes.profile} ${
            isProfileMenuOpen ? classes.profileOpen : ''
          }`}
        >
          <MenuItem
            Component={User}
            label="Profile"
            onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
          />
          {isProfileMenuOpen && (
            <ProfileMenu
              isVisible={isProfileMenuOpen}
              hideProfileMenuFn={() => setIsProfileMenuOpen(false)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
